// this is to stub it in tests
import h2c from "html2canvas";
export const html2canvas = (
  element: HTMLElement,
  options?: Html2Canvas.Html2CanvasOptions
): Html2CanvasPromise<HTMLCanvasElement> => h2c(element, options);
